import { useSearch } from "@/context/SearchContext";
import { Branding } from "@/types/branding";
import { I18nData } from "@/types/i18n";
import ResultCard from "./result-card";
import TableHeader from "./table-header";

interface Props {
  branding: Branding | null;
  i18nData: I18nData;
}

export default function MobileResults({ i18nData, branding }: Props) {
  const { searchResult } = useSearch();

  return (
    <div id="mobileResults">
      <table>
        <TableHeader paymentTitle={branding?.payment_title ?? "Who pays"} />
      </table>
      <div id="mobileResultTable" aria-live="assertive">
        {searchResult?.data.map((result) => (
          <ResultCard
            key={result._id}
            journal={result}
            i18nData={i18nData}
            branding={branding}
          />
        ))}
      </div>
    </div>
  );
}
